import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useChatBot } from '../utils/chatbotUtils';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { getActiveLoading } from '../store/loading-status/selectors';
import { Wave } from '../wave/Wave';
import { AppMessagingComponent } from './AppMessagingComponent';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
const FlowStepComponent = styled.div.withConfig({
  displayName: "AppViewComponent__FlowStepComponent",
  componentId: "ez626j-0"
})(["", " display:grid;align-content:center;flex:1;", " @media ", "{align-content:start;}@media ", "{justify-content:center;align-content:center;}"], props => props.theme.embedded && `  justify-content: center;
  align-content: center;`, props => props['data-loading'] && `align-content:center;`, devices.tablet, devices.desktop);
const ViewComponent = styled.div.withConfig({
  displayName: "AppViewComponent__ViewComponent",
  componentId: "ez626j-1"
})(["", " display:grid;grid-template-rows:minmax(65vh,max-content) auto;grid-area:main;", " @media ", "{width:100%;justify-self:center;grid-template-columns:50% 50%;grid-template-rows:auto;", "}@media ", "{max-width:calc(100% - 1 * (100% - 1201px));}"], props => props.theme.embedded && `grid-template-rows: auto;`, props => props.isWideStep && `grid-template-rows: 100%;`, devices.desktop, props => props.isWideStep && `grid-template-columns: 100%;`, devices.large);
/**
 * Embedded width calculated: Minimum of the max available witdth and the suggested width
 */

export const ContentHolder = styled.div.withConfig({
  displayName: "AppViewComponent__ContentHolder",
  componentId: "ez626j-2"
})(["width:100%;", " @media ", "{width:450px;overflow:visible;", "}"], props => props.theme.embedded && `width: \\min(calc(100vw - 2 * 1.25rem), 28rem);`, devices.desktop, props => props.isWideStep && ` width: 50rem;`);
const FlowStep = styled.div.withConfig({
  displayName: "AppViewComponent__FlowStep",
  componentId: "ez626j-3"
})(["display:flex;flex-direction:column;"]);
export const AppViewComponent = ({
  StepViewComponent
}) => {
  useChatBot();
  const {
    isWideStep,
    waveType
  } = useIsWideStep();
  const {
    currentStep
  } = useCurrentStep();
  const activeLoading = useSelector(getActiveLoading);
  return /*#__PURE__*/_jsxs(ViewComponent, {
    isWideStep: isWideStep,
    children: [/*#__PURE__*/_jsx(FlowStep, {
      children: /*#__PURE__*/_jsx(FlowStepComponent, {
        className: "FlowStepComponent",
        "data-loading": Boolean(activeLoading),
        "data-step": currentStep,
        children: /*#__PURE__*/_jsxs(ContentHolder, {
          isWideStep: isWideStep,
          children: [/*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx(UILoadingSpinner, {
              grow: true,
              size: "extra-small"
            }),
            children: /*#__PURE__*/_jsx(StepViewComponent, {})
          }), waveType && /*#__PURE__*/_jsx(Wave, {
            type: waveType
          })]
        })
      })
    }), /*#__PURE__*/_jsx(AppMessagingComponent, {})]
  });
};